import styled from 'styled-components';

export const Img = styled.img`
  display: block;
  width: 100%;
  height: auto;

  &.width-auto {
    width: auto;
    max-width: 100%;
  }
`;

interface ImageWrapperProps {
  ratio?: number;
}

export const ImageWrapper = styled.div<ImageWrapperProps>`
  &.fill {
    position: relative;
    padding-bottom: ${({ ratio = 1 }) => `${ratio * 100}%`};

    ${Img} {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;
